export enum SearchBarBehavior {
  OnHomePage = 'on-home-page',
  OnLandingWidget = 'on-landing-widget',
  OnResultsPage = 'on-results-page',
  OnResultDetail = 'on-result-detail-page',
}
